/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useMsal } from "@azure/msal-react"
import { Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { toast } from "react-hot-toast"
import { usePostRequest } from "../../../../api/helper"
import ArgosButton from "../../Buttons/ArgosButton"
import ArgosFlexbox from "../../Containers/ArgosFlexbox"
import ArgosMenuItem from "../../Form/Select/ArgosMenuItem"
import ArgosSelect from "../../Form/Select/ArgosSelect"
import ArgosTextField from "../../Form/TextField/ArgosTextField"
import Loader from "../../Loader/Loader"
import {hasThisAccessLevelToRouteKey} from "../../../../redux/ducks/AccessControl/accessControlHelpers";
import {EArgosRouteKeys} from "../../../../Routes/constants";
import {EUserPermissionAccess} from "../../../../redux/ducks/AccessControl/types";
import { getNodeById } from "../../../pages/CoverageRequirements/ItemDetails/Tabs/CoverageRequirementsTab/LeftPanelComponents/TreeComponent/CoverageRequirementsTreeComponent"
import VAR_COMMON_CONSTANTS from "../../../../constants/globalVariables"

const AddNewDatasetDialogContent = (props: any) => {
    const isEditDataset: boolean = props?.dialogType  == "editDataset"
    const contextNodeId = props?.contextNodeId != undefined ? props?.contextNodeId : ""
    const treeData = props?.treeData != undefined ? props?.treeData : {}

    const nodeData: any = getNodeById(treeData, contextNodeId)
    const [error, setError] = useState("");
    const [datasetName, setDataSetName] = useState(isEditDataset ? nodeData?.name : "");
    const [description, setDatasetDescription] = useState(isEditDataset ? nodeData?.description :"");
    const fetchHandle = usePostRequest("/HttpTriggerGetDataCoreSQL?container=Users");
    const {instance, accounts} = useMsal();
    const [owner, setDatasetOwner] = useState<any>({
        /*"id" : isEditDataset ? datasetData?.owner : accounts?.[0].username.split("@")[0],
        "firstName":isEditDataset ? datasetData?.description : accounts?.[0].name?.split(" ")[0], 
        "lastName": isEditDataset ? datasetData?.description : accounts?.[0].name?.split(" ")[1],*/
        "id" :  accounts?.[0].username.split("@")[0],
        "firstName": accounts?.[0].name?.split(" ")[0], 
        "lastName":  accounts?.[0].name?.split(" ")[1],  
    });
    const [isLoading, setIsLoading] = useState(false);
    const [possibleOwnersList, setPossibleOwnersList] = useState<any[]>([]);
    const [ownerName, setOwnerName] = useState<string>("")

    useEffect(()=>{
        setOwnerName(`${owner?.firstName} ${owner?.lastName}`)
    }, [owner])

    useEffect(()=>{
        fetchData()
    }, [])

    const fetchData = () => {
        setIsLoading(true);
        fetchHandle().
        then((data) => {
            setIsLoading(false);
            createOwnersList(data);
        })
        .catch((e) => {
            toast.error("Error querying the database");
            setIsLoading(false);
            console.log(e)
        })
    }
    const createOwnersList = (data: object[]) => {
        const filteredUsers: any[] =  data.filter((userInfo: any) =>  hasThisAccessLevelToRouteKey(EArgosRouteKeys.COVERAGE_REQUIREMENTS, userInfo, EUserPermissionAccess.READ_WRITE))
        const reformatUsers: any[] = filteredUsers.map((user: any) =>
            ({
                "id" : user["id"], 
                "firstName" : user["firstName"], 
                "lastName" : user["lastName"]
            })
        )

        if(isEditDataset){

            const user:any=reformatUsers.filter((element: any) => element.id == nodeData?.owner)[0]

            setDatasetOwner({
                "id": nodeData.owner,
                "firstName": user.firstName, 
                "lastName": user.lastName,  
            })

        }
        /*
        "id" : isEditDataset ? datasetData?.owner : accounts?.[0].username.split("@")[0],
        "firstName":isEditDataset ? possibleOwnersList.filter((element: any) => element.id == datasetData?.owner)[0]["firstName"] : accounts?.[0].name?.split(" ")[0], 
        "lastName": isEditDataset ? possibleOwnersList.filter((element: any) => element.id == datasetData?.owner)[0]["lastName"] : accounts?.[0].name?.split(" ")[1],
            */
        setPossibleOwnersList(reformatUsers)
    }
    const handleOwnerChange = (newValue: any) => {
        const newOwner = possibleOwnersList?.filter((element: any, index: number) => `${element["firstName"]} ${element["lastName"]}` == newValue)[0]
        setDatasetOwner(newOwner)
    }

    const hanldeModifyDataset = () => {
        const action: string = isEditDataset ? "editDataset" : "addNewDataset"
        const datasetOwner: string = isEditDataset ? owner["id"] : possibleOwnersList.filter((element: any) => element.firstName == owner.firstName && element.lastName == owner.lastName)[0]["id"]
        
        const _datasetData: any = {
            "name": datasetName,
            "owner": datasetOwner,
            "description": description
        }

        props.action(action, _datasetData)
        props.onClose()
    }
    const onChange = (e:any) => {
        const newValue = e.target.value;
        console.log(VAR_COMMON_CONSTANTS.VAR_FORBIDDEN_CHARS)
        if (!newValue.match(VAR_COMMON_CONSTANTS.VAR_FORBIDDEN_CHARS)) {
          setError("");
        } else {
          setError(VAR_COMMON_CONSTANTS.VAR_FORBIDDEN_CHARS_MSG);
        }
        setDataSetName(newValue)
    };
    return (
        <>
        <Loader isLoading={isLoading}>
            <ArgosFlexbox vertical>
                <ArgosTextField value={datasetName} type="text"
                                onChange={onChange}
                                label={VAR_COMMON_CONSTANTS.VAR_DATA_SET+" Name"}
                                helperText={error}
                                error={!!error}
                                />
                <ArgosFlexbox style={{alignItems: "center"}}>
                    <Typography>Owner:</Typography>
                    <ArgosSelect
                        style={{flexGrow: 1}}
                        value={ownerName}
                        //disabled={isEditDataset}
                        onChange={(e) => handleOwnerChange(e.target.value)}>
                            {
                                possibleOwnersList?.map((element: any, index: number) => 
                                <ArgosMenuItem 
                                    key={index} 
                                    value={`${element["firstName"]} ${element["lastName"]}`}
                                > 
                                    {`${element["firstName"]} ${element["lastName"]}`}
                                </ArgosMenuItem>)}
                    </ArgosSelect>
                </ArgosFlexbox>
                
                <ArgosTextField multiline={true}
                                rows={4}
                                value={description} type="text"
                                onChange={(e) => setDatasetDescription(e.target.value)}
                                label="Description"
                                />
                <ArgosFlexbox style={{justifyContent: "center"}}>
                    <ArgosButton onClick={() => props.onClose()}>
                        Cancel
                    </ArgosButton>
                    <ArgosButton disabled={ownerName == "" || datasetName == "" || !!error} onClick={() => hanldeModifyDataset()}>
                        { isEditDataset ? "Save": "Add"}
                    </ArgosButton>
                </ArgosFlexbox>
            </ArgosFlexbox>
        </Loader>
          
        </>
    )
}
export default AddNewDatasetDialogContent;



